import { Product, Purpose } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { MarketCountryCode } from '@axo/shared/types';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';

const unfilteredLoanPurposes = (
  [
    { value: null },
    {
      value: Purpose.Other,
      whitelist: [{ productType: [Product.UnsecuredLoan] }],
    },
    {
      value: Purpose.RefinancingLoan,
      whitelist: [{ productType: [Product.UnsecuredLoan] }],
    },
    {
      value: Purpose.Renovation,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden, MarketCountryCode.Denmark],
        },
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Finland],
          broker: [Broker.Axo],
        },
      ],
    },
    {
      value: Purpose.Vehicle,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [
            MarketCountryCode.Finland,
            MarketCountryCode.Sweden,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: Purpose.Holiday,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden, MarketCountryCode.Denmark],
        },
      ],
    },
    {
      value: Purpose.Medical,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden, MarketCountryCode.Denmark],
        },
      ],
    },
    {
      value: Purpose.PropertyDivision,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.HomeInteriorDesign,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden, MarketCountryCode.Finland],
          broker: [Broker.Axo],
        },
      ],
    },
    {
      value: Purpose.EstateInventory,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.DebtCollection,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Investment,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [
            MarketCountryCode.Sweden,
            MarketCountryCode.Finland,
            MarketCountryCode.Denmark,
          ],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.InvestmentOwnCompany,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Consumption,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden, MarketCountryCode.Finland],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.DrivingLicense,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Studies,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Dentist,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Housing,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Finland],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.Wedding,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Sweden],
          broker: [Broker.Zmarta],
        },
      ],
    },
    {
      value: Purpose.RealEstate,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Denmark],
        },
      ],
    },
    {
      value: Purpose.SpecialOccasion,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Denmark],
        },
      ],
    },
    {
      value: Purpose.GreenEnergy,
      whitelist: [
        {
          productType: [Product.UnsecuredLoan],
          marketCountry: [MarketCountryCode.Denmark],
        },
      ],
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    Purpose | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useLoanPurposeOptions = () =>
  useApplicationConditionalFilter(unfilteredLoanPurposes);
